import api from './api';
import type { Note, CreateNoteRequest, UpdateNoteRequest, NotesByDateResponse } from '../types/note';

export const noteApi = {
    // Get notes by date
    async getNotesByDate(date: string): Promise<Note[]> {
        const response = await api.get<NotesByDateResponse>(`/notes/${date}`);
        return response.data.notes;
    },

    // Get all notes with pagination
    async getNotes(page = 1, limit = 20): Promise<Note[]> {
        const response = await api.get('/notes', { params: { page, limit } });
        return response.data.notes;
    },

    // Create note
    async createNote(data: CreateNoteRequest): Promise<Note> {
        const response = await api.post<Note>('/notes', data);
        return response.data;
    },

    // Update note
    async updateNote(id: string, data: UpdateNoteRequest): Promise<Note> {
        const response = await api.put<Note>(`/notes/${id}`, data);
        return response.data;
    },

    // Delete note
    async deleteNote(id: string): Promise<void> {
        await api.delete(`/notes/${id}`);
    },
};

export default noteApi;
